import React, { useRef } from 'react'
import Slider from 'react-slick';
import Test_01 from '../../../assets/images/about/about-user-1.png';
import Test_02 from '../../../assets/images/about/about-user-2.png';
import Test_03 from '../../../assets/images/about/about-user-3.png';
import Test_04 from '../../../assets/images/about/about-user-4.png';
import Test_05 from '../../../assets/images/about/about-user-5.png';
import Test_06 from '../../../assets/images/testimonial/teshtimonial-three-1.png';
import Test_07 from '../../../assets/images/testimonial/testimonial-detail-1.png';
import Test_08 from '../../../assets/images/testimonial/testimonial-detail-2.png';
import Test_qute from '../../../assets/images/testimonial/testimonial-three-qute.svg';
import Test_pre from '../../../assets/images/svg/aerrow-pre.svg';
import Test_next from '../../../assets/images/svg/aerrow-next.svg';


const Testimonial = () => {
    const sliderOneRef = useRef(null);
    const sliderTwoRef = useRef(null);

    const sliderOneSettings = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: false,
        asNavFor: sliderTwoRef.current,
    };

    const sliderTwoSettings = {
        speed: 500,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
        fade: true,
        dots: false,
        arrows: true,
        prevArrow: (
            <button type="button" className="slick-prev">
                <img src={Test_pre} alt="prev-icon" />
            </button>
        ),
        nextArrow: (
            <button type="button" className="slick-next">
                <img src={Test_next} alt="next-icon" />
            </button>
        ),
        asNavFor: sliderOneRef.current,
    };
    return (
        <>
            <div className="testimonial-section-three">
                <div className="container">
                    <div className="row gutter-y-40">
                        <div className="col-lg-5">
                            <div className="testimonial-left-three">
                                <div className="heading-box">
                                    <h2
                                        className="heading-title animate fadeInUp wow"
                                        data-wow-duration="1500ms"
                                    >
                                        Happy Users Around From Worlds
                                    </h2>
                                </div>
                                <p
                                    className="lead animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="200ms"
                                >
                                    Bring your ideas to life with an intuitive visuals editor. Create,
                                    edit, and customize your website visually and see the changes
                                    instantly.
                                </p>
                                <div
                                    className="testimonial-user-three animate fadeInUp wow"
                                    data-wow-duration="1500ms"
                                    data-wow-delay="400ms"
                                >
                                    <ul>
                                        <li>
                                            <img
                                                src={Test_01}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Test_02}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Test_03}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Test_04}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Test_05}
                                                alt="user-images"
                                            />
                                        </li>
                                    </ul>
                                    <p>Trusted by 5000+ Worldwide Brands &amp; Customers</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7">
                            <div
                                className="testimonial-slider-three animate fadeInRight wow"
                                data-wow-duration="1500ms"
                                data-wow-delay="200ms"
                            >
                                <Slider ref={sliderOneRef} className="testimonial-slider-three-1" {...sliderOneSettings} >
                                    <div className="testimonial-item-three-1">
                                        <div className="testimonial-image-three-1">
                                            <img
                                                src={Test_06}
                                                alt="testimonial-image"
                                            />
                                        </div>
                                        <h4>Satisfied clients</h4>
                                        <p>Chif Designer</p>
                                    </div>
                                    <div className="testimonial-item-three-1">
                                        <div className="testimonial-image-three-1">
                                            <img
                                                src={Test_07}
                                                alt="testimonial-image"
                                            />
                                        </div>
                                        <h4>Satisfied clients</h4>
                                        <p>Strategic Vision</p>
                                    </div>
                                    <div className="testimonial-item-three-1">
                                        <div className="testimonial-image-three-1">
                                            <img
                                                src={Test_08}
                                                alt="testimonial-image"
                                            />
                                        </div>
                                        <h4>Satisfied clients</h4>
                                        <p>Innovation </p>
                                    </div>
                                </Slider>
                                <Slider ref={sliderTwoRef} className="testimonial-slider-three-2" {...sliderTwoSettings}>
                                    <div className="testimonial-item-three-2">
                                        <div className="testimonial-icon-three-1">
                                            <img
                                                src={Test_qute}
                                                alt="icon"
                                            />
                                        </div>
                                        <p>
                                            Our people are the heart of our operations, which is why we’re
                                            fanatical about finding the brightest problem solvers in the
                                            industry, and giving them make a difference.
                                        </p>
                                    </div>
                                    <div className="testimonial-item-three-2">
                                        <div className="testimonial-icon-three-1">
                                            <img
                                                src={Test_qute}
                                                alt="icon"
                                            />
                                        </div>
                                        <p>
                                            Our team is the core of everything we do. We are passionate the
                                            most brilliant problem-solvers in the field and empowering them
                                            to create meaningful change.
                                        </p>
                                    </div>
                                    <div className="testimonial-item-three-2">
                                        <div className="testimonial-icon-three-1">
                                            <img
                                                src={Test_qute}
                                                alt="icon"
                                            />
                                        </div>
                                        <p>
                                            At the heart of our success lies our people. We are dedicated
                                            the best minds in the industry and providing them with the tools
                                            and opportunities to make a real impact.
                                        </p>
                                    </div>
                                </Slider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Testimonial
